/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type CustomerSignup_AccountQueryVariables = {};
export type CustomerSignup_AccountQueryResponse = {
    readonly viewer: {
        readonly userAccounts: ReadonlyArray<{
            readonly id: string;
        }> | null;
    } | null;
};
export type CustomerSignup_AccountQuery = {
    readonly response: CustomerSignup_AccountQueryResponse;
    readonly variables: CustomerSignup_AccountQueryVariables;
};



/*
query CustomerSignup_AccountQuery {
  viewer {
    userAccounts {
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Account",
  "kind": "LinkedField",
  "name": "userAccounts",
  "plural": true,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerSignup_AccountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CustomerSignup_AccountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3886bca263095cc989a6a73937115802",
    "id": null,
    "metadata": {},
    "name": "CustomerSignup_AccountQuery",
    "operationKind": "query",
    "text": "query CustomerSignup_AccountQuery {\n  viewer {\n    userAccounts {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '2f2b8f23164f94a268fb1027dcbe906c';
export default node;
